import { useState, useEffect } from 'react'
import { useAppStore } from '../../stores/app'
import { useUpdateProfile } from '../../hooks/useUpdateProfile'

const PROFILE_ROLES = [
  { value: 'admin', label: 'Admin' },
  { value: 'editor', label: 'Editor' },
  { value: 'viewer', label: 'Viewer' },
] as const

export function SettingsProfileSection() {
  const currentUser = useAppStore((state) => state.currentUser)
  const updateProfile = useUpdateProfile()
  const [fullName, setFullName] = useState('')
  const [role, setRole] = useState<string>('')
  const [feedback, setFeedback] = useState<{ type: 'success' | 'error'; message: string } | null>(null)

  useEffect(() => {
    if (currentUser) {
      setFullName(currentUser.full_name ?? '')
      setRole(currentUser.role ?? '')
    }
  }, [currentUser])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setFeedback(null)
    if (!currentUser?.id) return
    try {
      await updateProfile.mutateAsync({
        userId: currentUser.id,
        full_name: fullName.trim() || null,
        role: role || null,
      })
      setFeedback({ type: 'success', message: 'Perfil actualizado correctamente.' })
    } catch {
      setFeedback({ type: 'error', message: 'No se pudo actualizar el perfil. Intenta de nuevo.' })
    }
  }

  if (!currentUser) {
    return (
      <div className="card">
        <h2 className="text-lg font-semibold text-slate-800 mb-2">Perfil</h2>
        <p className="text-slate-500">Carga tu perfil para editarlo.</p>
      </div>
    )
  }

  return (
    <div className="card">
      <h2 className="text-lg font-semibold text-slate-800 mb-4">Perfil</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="profile-full-name" className="label">
            Nombre completo
          </label>
          <input
            id="profile-full-name"
            type="text"
            className="input"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            placeholder="Tu nombre"
          />
        </div>
        <div>
          <label htmlFor="profile-role" className="label">
            Rol
          </label>
          <select
            id="profile-role"
            className="input"
            value={role}
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="">Seleccionar...</option>
            {PROFILE_ROLES.map((r) => (
              <option key={r.value} value={r.value}>
                {r.label}
              </option>
            ))}
          </select>
        </div>
        {feedback && (
          <p
            className={`text-sm ${feedback.type === 'success' ? 'text-green-600' : 'text-red-600'}`}
            role="alert"
          >
            {feedback.message}
          </p>
        )}
        <button
          type="submit"
          className="btn btn-primary"
          disabled={updateProfile.isPending}
        >
          {updateProfile.isPending ? 'Guardando...' : 'Guardar'}
        </button>
      </form>
    </div>
  )
}
